import React, { useState, useEffect, useRef } from "react";
import Header from "../../layout/header";
import Footer from "../../layout/footer";

import footer from "../../assets/img/bg-archives.jpg";

import Accordion from "react-bootstrap/Accordion";
import Loading from "../../components/loading";

import { getData } from "../../services/getService";

const CentresOverview = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [dataOne, setDataOne] = useState({});
  const [dataTwo, setDataTwo] = useState({});
  const [dataH, setDataH] = useState({});
  const called = useRef(true);

  useEffect(() => {
    if (called.current) {
      Promise.all([fetchDataOne()]).then((res) => {
        setIsLoading(false);
      });
    }
    return () => {
      called.current = false;
    };
  }, []);

  const fetchDataOne = async () => {
    getData("vinformation", "")
      .then((response) => {
        if (response.status === "success") {
          setDataOne(response.data);
        }
      })
      .catch((e) => {
        console.log(e.response.data.error);
      });
  };

  const allowedCatIds = ["virtual", "other"];
  const allowedCatIds2 = ["capacity"];

  // --- เพิ่มฟังก์ชันสำหรับจัดกลุ่มข้อมูลที่ชื่อเหมือนกัน ---
  const getGroupedData = (data, filterCondition) => {
    if (!data || !data.length) return [];

    // กรองข้อมูลตามหมวดหมู่ที่ต้องการก่อน
    const filtered = data.filter(filterCondition);

    // จัดกลุ่มข้อมูลโดยใช้ name เป็นตัวหลัก
    return filtered.reduce((acc, curr) => {
      const existing = acc.find((item) => item.name === curr.name);
      if (existing) {
        // ถ้ามีชื่อนี้อยู่แล้ว ให้เพิ่มแค่ id กับ year เข้าไปใน array
        existing.links.push({ id: curr.id, year: curr.year });
      } else {
        // ถ้ายังไม่มีชื่อนี้ ให้สร้างชุดข้อมูลใหม่
        acc.push({
          name: curr.name,
          links: [{ id: curr.id, year: curr.year }],
        });
      }
      return acc;
    }, []);
  };

  return (
    <>
      <div id="outer-container" style={{}}>
        <Header page="news" sub="archives" />
        <div className="wrapper bg-white box-index">
          {isLoading ? <Loading /> : null}

          <section
            className="position-relative pb-5 pt-5 bg-top-cover"
            style={{
              backgroundImage: `url(${footer})`,
              backgroundRepeat: "no-repeat",
            }}
          >
            <div className="container-fluid pb-5 px-lg-5">
              <div className="row justify-content-center">
                <div className="col-12 col-md-11 col-lg-11">
                  <div className="row align-items-center mb-3 mb-md-5 mt-lg-5">
                    <div className="col-12 col-md-12 col-lg-12 text-start">
                      <div className="font-60 weight-700">Archives</div>
                    </div>
                  </div>
                  <div className="text-start">
                    <div className="sub-topic mb-4 yellow-black">
                      Programmes and Activities
                    </div>
                    <Accordion defaultActiveKey="2" className="custom-li">
                      <Accordion.Item eventKey="2">
                        <Accordion.Header>Capacity Building</Accordion.Header>
                        <Accordion.Body>
                          <ul>
                            {/* เรียกใช้ฟังก์ชันจัดกลุ่มแทน */}
                            {dataOne.length
                              ? getGroupedData(dataOne, (val) =>
                                  allowedCatIds2.includes(val.catId)
                                ).map((group, index) => (
                                  <li key={index}>
                                    {group.name}
                                    {/* วนลูปสร้างปุ่มปีทั้งหมดที่ถูกจัดกลุ่มไว้ */}
                                    {group.links.map((link, i) => (
                                      <span key={i}>
                                        {" "}
                                        <a
                                          href={
                                            "/newsandgallery/archivesOpacity/" +
                                            link.id
                                          }
                                        >
                                          {link.year}
                                        </a>
                                      </span>
                                    ))}
                                  </li>
                                ))
                              : null}
                          </ul>
                        </Accordion.Body>
                      </Accordion.Item>

                      <Accordion.Item eventKey="0">
                        <Accordion.Header>
                          Information Exchange
                        </Accordion.Header>
                        <Accordion.Body>
                          <ul>
                            {/* ทำแบบเดียวกันในหมวดอื่นๆ เผื่อในอนาคตมีชื่อซ้ำกัน */}
                            {dataOne.length
                              ? getGroupedData(dataOne, (val) =>
                                  allowedCatIds.includes(val.catId)
                                ).map((group, index) => (
                                  <li key={index}>
                                    {group.name}
                                    {group.links.map((link, i) => (
                                      <span key={i}>
                                        {" "}
                                        <a
                                          href={
                                            "/newsandgallery/archives/" +
                                            link.id
                                          }
                                        >
                                          {link.year}
                                        </a>
                                      </span>
                                    ))}
                                  </li>
                                ))
                              : null}
                          </ul>
                        </Accordion.Body>
                      </Accordion.Item>

                      <Accordion.Item eventKey="1">
                        <Accordion.Header>
                          Partnership and Linkages
                        </Accordion.Header>
                        <Accordion.Body>
                          <ul>
                            {dataOne.length
                              ? getGroupedData(
                                  dataOne,
                                  (val) => val.catId === "waste"
                                ).map((group, index) => (
                                  <li key={index}>
                                    {group.name}
                                    {group.links.map((link, i) => (
                                      <span key={i}>
                                        {" "}
                                        <a
                                          href={
                                            "/newsandgallery/archivesWaste/" +
                                            link.id
                                          }
                                        >
                                          {link.year}
                                        </a>
                                      </span>
                                    ))}
                                  </li>
                                ))
                              : null}
                          </ul>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </div>

                  <div className="text-start mt-5 pt-5">
                    <div className="sub-topic mb-4 yellow-black">
                      Awards and Grants
                    </div>
                    <Accordion defaultActiveKey="0" className="custom-li">
                      <Accordion.Item eventKey="2">
                        <Accordion.Header>SEAMEO SEPS Awards</Accordion.Header>
                        <Accordion.Body>
                          <ul>
                            {dataOne.length
                              ? getGroupedData(
                                  dataOne,
                                  (val) => val.catId === "awards"
                                ).map((group, index) => (
                                  <li key={index}>
                                    {group.name}
                                    {group.links.map((link, i) => (
                                      <span key={i}>
                                        {" "}
                                        <a
                                          href={
                                            "/newsandgallery/archivesAwards/" +
                                            link.id
                                          }
                                        >
                                          {link.year}
                                        </a>
                                      </span>
                                    ))}
                                  </li>
                                ))
                              : null}
                          </ul>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <Footer page="news" sub="archives" />
        </div>
      </div>
    </>
  );
};

export default CentresOverview;
